import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const creativesTrackingAPI = createApi({
  reducerPath: 'CreativesTrackingAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Creative' }),
  tagTypes: [],
  endpoints: (build) => ({
    getCreativesAndTrackingData: build.query({
      query: (term) => ({
        url: `/LoadCreativeAndTrackingData`,
        params: {
          ...term,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: [],
    }),
    getCreativesAndTrackingData_new_empty: build.query({
      query: (term) => ({
        url: `/GetCreativeAndTrackingData`,
        params: {
          ...term,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: [],
    }),
    getCreativesList: build.query({
      query: ({ creativesCampaignId }) => ({
        url: `/GetCreativesList`,
        params: {
          creativesCampaignId,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: [],
    }),
  }),
});
